import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  RadioGroupForm,
  Heading,
} from "@ogt/ui";

export const ADULT = "adult";
export const NOT_ADULT = "not_adult";

export default function AgeCheck() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 55;

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          const agecheckChanged = values.agecheck !== formData.agecheck;

          setFormData({
            ...formData,
            ...values,
            ...(agecheckChanged && {
              firstname: "",
              lastname: "",
              email: "",
              phone: "",
              reporterEmail: "",
            }),
          });

          if (values.agecheck === ADULT) {
            navigate("/vem-overklagar-du-for");
          } else if (values.agecheck === NOT_ADULT) {
            navigate("/kontaktuppgifter");
          }
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          agecheck: Yup.string().test(
            "at-least-one-radio-selected",
            "Frågan “Är du över 18 år” saknar svar ",
            (value) => {
              return value === ADULT || value === NOT_ADULT;
            }
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading
                  headingRef={h2Ref}
                  focusable
                  id="ageCheckHeading"
                  progress={progress}
                >
                  Är du över 18 år?
                </Heading>

                <p>
                  Om du är under 18 år behöver du ange en mejladress till en
                  vårdnadshavare, god man eller ett ombud.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <RadioGroupForm
                  ariaLabelledBy="ageCheckHeading"
                  name="agecheck"
                  options={[
                    {
                      id: "adult",
                      value: "adult",
                      label: "Ja, jag är över 18",
                    },
                    {
                      id: "not_adult",
                      value: "not_adult",
                      label: "Nej, jag är under 18 år",
                    },
                  ]}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button onClick={handleSubmitClick(formRef)} type="submit">
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
